import * as React from "react";
import { useState } from "react";
import { Box } from "@mui/material";
import { styled } from "@mui/system";

import TabsUnstyled from "@mui/base/TabsUnstyled";
import TabsListUnstyled from "@mui/base/TabsListUnstyled";
import TabPanelUnstyled from "@mui/base/TabPanelUnstyled";
import TabUnstyled, {
  tabUnstyledClasses,
} from "@mui/base/TabUnstyled";
import { buttonUnstyledClasses } from "@mui/base/ButtonUnstyled";

import ActiveClientReview from "./ActiveClientReview";
import RenewalClientReview from "./RenewalClientReview";

const white = {
  50: "#fff",
  100: "#fff",
  200: "#fff",
  300: "#fff",
  400: "#fff",
  500: "#F2F4F7",
  600: "#030202",
  700: "#0059B2",
  800: "#fff",
  900: "#fff",
};

const Tab = styled(TabUnstyled)`
  font-family: IBM Plex Sans, sans-serif;
  flex: 1;
  color: #000;
  cursor: pointer;
  font-size: 14px;
  font-weight: 600;
  background: transparent;
  padding: 12px 10px;
  border: none;
  border-radius: 6px;
  text-align: center;
  line-height: 1.3;
  white-space: normal;
  word-break: break-word;
  transition: all 0.2s ease;

  &:hover {
    background: ${white[50]};
  }

  &.${tabUnstyledClasses.selected} {
    background: ${white[50]};
    color: ${white[600]};
    box-shadow: 0px 2px 8px rgba(0, 0, 0, 0.12);
  }

  &.${buttonUnstyledClasses.disabled} {
    opacity: 0.5;
    cursor: not-allowed;
  }

  @media (max-width: 600px) {
    font-size: 13px;
    padding: 10px 6px;
  }
`;

const TabsList = styled(TabsListUnstyled)`
  width: 100%;
  max-width: 550px;
  background: ${white[500]};
  border-radius: 8px;
  display: flex;
  padding: 4px;
  margin-bottom: 20px;   
`;

const TabPanel = styled(TabPanelUnstyled)`
  width: 100%;
`;

export default function ClientReviewTab() {
  const [value, setValue] = useState(0);

  return (
    <Box
      sx={{
        width: "100%",
        display: "flex",
        flexDirection: "column",
        alignItems: "flex-start", // Left align
        px: {
          xs: 1,
          sm: 2,
          md: 3,
        },
      }}
    >
      <Box
        sx={{
          mb: 2,
          display: "flex",
          alignItems: "center",
        }}
      >
        <span
          style={{
            fontSize: "24px",
            fontWeight: 600,
            color: "#1A2332",
            fontFamily: "Roboto, sans-serif",
            letterSpacing: "0.3px",
          }}
        >
          Client Review Questionnaires
        </span>
      </Box>
      <Box sx={{ width: "100%" }}>
        <TabsUnstyled value={value} onChange={(e, v) => setValue(v)}>

          <TabsList>
            <Tab>Current </Tab>
            <Tab>Renewal</Tab>
          </TabsList>

          <Box sx={{ width: "100%" }}>
            <TabPanel value={0}>
              <ActiveClientReview />
            </TabPanel>

            <TabPanel value={1}>
              <RenewalClientReview />
            </TabPanel>
          </Box>

        </TabsUnstyled>
      </Box>
    </Box>


  );
}